import { Component, OnInit } from '@angular/core';
import {
	FormControl,
	FormGroup
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';

import { User } from 'src/app/shared/models/security/user';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { SuiviPrestation } from 'src/app/shared/models/suiviPrestation';
import { Prestation } from 'src/app/shared/models/prestation';

@Component({
	selector: 'app-suiviPrestation-modal-ajout',
	templateUrl: './suiviPrestation-modal-ajout.component.html',
	styleUrls: ['./suiviPrestation-modal-ajout.component.scss']
})
export class SuiviPrestationModalAjoutComponent implements OnInit {
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };
	isAddressSelected: { value: boolean } = { value: false };

	LABEL_INTERVENANT: string;

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+$");
	PHONE_NUMBER_PATTERN = '0{1}[0-9]{9}';

	formAjout: FormGroup = new FormGroup(
		{
			dateEntretien: new FormControl<Date>(null),
			dateProchainEntretien: new FormControl<Date>(null),
			description: new FormControl(''),
			typeEntretien: new FormControl(''),
			modaliteReunion: new FormControl(''),
		}
	);

	prestation: Prestation = null;
	user: User;
	suiviPrestation = new SuiviPrestation();

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		public bsModalRef: BsModalRef
	) {}

	ngOnInit(): void {
		this.LABEL_INTERVENANT = this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
		this.user = this.facade.dataStorageService.getUser();
		if (this.user) {
			//this.center = this.user.suiviPrestation.serviceCenter;
		}

		const prestationId = +this.router.url.split('/').pop();
		this.facade.prestationService
			.getPrestationById(prestationId)
			.subscribe((prestation: Prestation) => {
				this.prestation = prestation;
			});
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.suiviPrestation.prestation = this.prestation;
		console.log(this.suiviPrestation);
		this.facade.suiviPrestationService.addSuiviPrestation(this.suiviPrestation).subscribe({
			complete: () => {
				this.isValidateButtonClicked.value = false;
				this.bsModalRef.hide();
				this.reload();
			},
			error: (err: ErrorResponse) => {
				this.isValidateButtonClicked.value = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message,
					err.status
				);
			}
		});
	}
}

